import { AccountStateKey } from '../account/account';
import {
  IdIdentifier,
  TimeIdentifiers,
  UserIdentifier,
} from '../common/identifiers';

export type CreditTransaction = IdIdentifier &
  TimeIdentifiers &
  UserIdentifier & {
    amount: number;
    type: CreditType;
    action: CreditAction;
    notes?: string;
    internalNotes?: string;
    accountId?: string;
    expirationDate?: string;
    purchaseId?: string;
    createdByUserId?: string;
    creditIds?: string[];
    metadata?: CreditMetadata;
  };

export interface CreditMetadata {
  accountState?: AccountStateKey;
  withdrawalSocialMediaPromotion?: boolean;
}

export enum CreditAction {
  Add = 'add',
  Deduct = 'deduct',
}

export enum CreditType {
  Test = 'test',
  PassedEvaluation = 'passed-evaluation',
  AccountStateChange = 'account-state-change',
  Payment = 'payment',
  Prize = 'prize',
  Contest = 'contest',
  Payout = 'payout',
  Bulk = 'bulk',
}

export type BulkAddCreditPayload = {
  index: number;
  user_id: string;
  email?: string;
  credit_type: CreditType;
  credit_amount: number;
  expiry_days: number;
  notes?: string;
  internal_notes?: string;
};

export type BulkAddCredit = {
  index: number;
  userId: string;
  amount: number;
  type: CreditType;
  action: CreditAction;
  expirationDate: string;
  notes?: string;
  internalNotes?: string;
};

export type BulkAddCreditFulfilledItem = BulkAddCredit & {
  index: number;
};

export type BulkAddCreditSkippedItem = {
  index: number;
  userId: string;
  reason: string;
};

export type BulkAddCreditRejectedItem = {
  index: number;
  userId: string;
  amount: number;
  error: string;
};

export type BulkAddCreditResult = {
  fulfilled: BulkAddCreditFulfilledItem[];
  rejected: BulkAddCreditRejectedItem[];
  skipped: BulkAddCreditSkippedItem[];
};
export enum CreditCategory {
  Profit = 'profit',
  Refund = 'refund',
}
